var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _vm.component,
    {
      tag: "component",
      staticClass: "day--container",
      class: _vm.dayClasses,
      attrs: {
        "data-day-number": _vm.day.TITLE,
        href: _vm.href,
        "data-day-offer": _vm.day.OFFER_CODE,
        "data-day-offer-strike": _vm.day.OFFER_CODE_STRIKE,
        "data-day-min-nights": _vm.day.MIN_NIGHTS,
        "aria-label": _vm.ariaLabel,
        "aria-hidden": _vm.ariaHidden,
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.handleDayClick.apply(null, arguments)
        },
        keydown: _vm.handleDayKeydown,
      },
    },
    [
      _c("span", { staticClass: "day--marker" }),
      _vm._v(" "),
      _c("span", { staticClass: "day--number" }, [
        _vm._v(_vm._s(_vm.day.TITLE)),
      ]),
      _vm._v(" "),
      _vm.day.PRICE > 0
        ? _c("span", { staticClass: "day--price" }, [
            _vm._v("$" + _vm._s(_vm.day.PRICE)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }